import Link from 'next/link';
import { useRouter } from 'next/router';
import { useLoggedinUser } from "lib/hooks";
import { useDisclosure, Box } from "@chakra-ui/react";
import { VerifyAlertDialog } from "components";
import { isPreviewingPack } from "lib/utils";

export const Menu = () => {
  const { pathname, asPath } = useRouter();
  const { data: user } = useLoggedinUser();
  const verifyDialog = useDisclosure();

  if (isPreviewingPack(pathname) || !user) {
    return null;
  }

  const selectedPacksMenu = asPath.includes('#') ? asPath.substring(asPath.indexOf('#')+1) : 'all';

  const isPacks = pathname === '/packs' && selectedPacksMenu === 'all';
  const isTemplates = pathname === '/templates';

  return (
    <nav className="menu">
      <ul className="nav">
        <li className="nav-item">
          <Link href="/packs" passHref>
            <a className={`nav-item__link ${isPacks ? 'nav-item__link--select': ''}`}>
              Packs
            </a>
          </Link>
        </li>
        <li className="nav-item">
          <Link href="/templates" passHref>
            <a className={`nav-item__link ${isTemplates ? 'nav-item__link--select': ''}`}>
              Templates
            </a>
          </Link>
       </li>
      </ul>
      <VerifyAlertDialog
        isOpen={verifyDialog.isOpen}
        onClose={verifyDialog.onClose}
        content={`To view and create Team packs, you need to complete your account set up. It’s super easy. We sent a verification link to ${user?.email}. Please go to your inbox and click that link to get full access to your Packs account.`}
        title={"You’re so close! One final step."}
      />
    </nav>
  )
};
